import * as React from 'react';
import moment from 'moment';
import '../styles/DBAContentBoots.css';

interface DBAContentsTop {
  revisitingLead: boolean;
  firstName: string;
  lastName: string;
  houseNumName: string,
  streetRoad: string,
  town: string,
  postCode: string,
  country: string,
}

const DBAContentBoots: React.SFC<DBAContentsTop> = props => {
  return (
    <React.Fragment>
      <div>
        <div className="boots-table">
          <div className="boots-cell">
            <img className="boots-images" src="https://payjustice.co.uk/wp-content/uploads/2014/05/PayJusticeLogo_FullSize.png" alt="logo" />
          </div>
          <div className="boots-cell">
          </div>
          <div className="boots-cell">
          </div>
          <div className="boots-cell">
            <img className="boots-images" src="http://www.roscoereid.com/wp-content/uploads/2018/01/Roscoe-Reid_logo.png" alt="logo" />
          </div>
        </div>

        <p className="p3 boots-border"><span className="s1"><b>This document is your damages-based agreement. It is important that you read its
        terms very carefully before signing it. Once it is signed it forms a legally binding contract between you and
      Roscoe Reid.<span className="Apple-converted-space">&nbsp;</span></b></span>
        </p>

        <br /><br />

        <p className="p4"><span className="s1"><b>THIS AGREEMENT </b>is dated {moment().format('DD/MM/YYYY')}<br /><br /> <b>Parties<span className="Apple-converted-space">&nbsp;</span></b></span></p>

        <p className="p4"><span className="s1"><b>DAMAGES BASED AGREEMENT<span className="Apple-converted-space">&nbsp;</span></b></span></p>
        <ul className="ul1">
          {props.revisitingLead ?
            (<li className="li4"><span className="s1">(1) &nbsp;<b>You will receive a copy of this agreement with your details applied</b>, for legal purposes you will be referred to below as <b>"you", "your"</b>. </span><span className="s2"><br /></span></li>) :
            (<li className="li4"><span className="s1">(1) &nbsp;{props.firstName} {props.lastName}, {props.houseNumName} {props.streetRoad}, {props.town}, {props.postCode}, {props.country} (<b>"you", "your"</b>). </span><span className="s2"><br />
            </span>
            </li>)
          }
          <li className="li4"><span className="s1">(2) &nbsp;Roscoe Reid LLP, whose registered office is at 5th Floor Free Trade Exchange, 37 Peter Street, Manchester,
         M2 5GB </span><span className="s2"><br />
            </span><span className="s1"><b>("we", "us", "our", "Roscoe Reid"</b>). </span><span className="s2"><br />
            </span>
          </li>
        </ul>
        <p className="p4">
          <span className="s1">
            You confirm that you have read the note headed "<i>Important Information - You Must
            Read This Before Signing The Damages Based Agreement (DBA)</i>" (the "<b>Information Sheet</b>") before signing
            this Agreement. This Information Sheet which was displayed to you on your screen immediately before this DBA was
            displayed to you and you confirmed that you have read it by proceeding to this stage. If you have been provided
            with paper copies, then the Information Sheet is enclosed with this DBA.<span className="Apple-converted-space">&nbsp;</span>
          </span>
        </p>
        <p className="p4"><span className="s1"><b>1. Definitions<span className="Apple-converted-space">&nbsp;</span></b></span></p>
        <p className="p4"><span className="s1">In this Agreement, unless the context otherwise requires, the following words and
      expressions have the following meanings:<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <p className="p4"><span className="s1"><b>Compensation: </b>the gross sums ultimately recovered by you as a result of your
           Claim, including any award of back pay, damages and/or interest, where applicable before deduction of tax and/or
      national insurance, but excluding legal costs awarded to you by the court.<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <p className="p4"><span className="s1"><b>Costs and Expenses: </b>The total of<span className="Apple-converted-space">&nbsp;</span></span></p>
        <ul className="ul1">
          <li className="li4"><span className="s1">(a) &nbsp;Our fees (calculated in accordance with the Information Sheet); </span><span className="s2"><br />
          </span>
          </li>
          <li className="li4"><span className="s1">(b) &nbsp;Counsel’s Fees: and </span><span className="s2"><br />
          </span>
          </li>
          <li className="li4"><span className="s1">(c) &nbsp;Disbursements </span><span className="s2"><br />
          </span>
          </li>
        </ul>
        <p className="p4"><span className="s1"><b>Counsel: </b>members of the Bar of England &amp; Wales retained where required by
      Roscoe Reid to work on the Claim.<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <p className="p4"><span className="s1"><b>Counsel’s Fees: </b>fees payable to any Counsel.<span className="Apple-converted-space">&nbsp;</span></span></p>



        <p className="p4"><span className="s1"><b>Claim</b>: Your claim for equal pay against your employer including court or
           employment tribunal proceedings; together with related claim connected to your claim for equal pay, including but
      not limited to:<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <ul className="ul1">
          <li className="li4"><span className="s1">(a) &nbsp;Age discrimination; </span><span className="s2"><br />
          </span>
          </li>
          <li className="li4"><span className="s1">(b) &nbsp;Sex discrimination; </span><span className="s2"><br />
          </span>
          </li>
          <li className="li4"><span className="s1">(c) &nbsp;Unfair dismissal; </span><span className="s2"><br />
          </span>
          </li>
          <li className="li4"><span className="s1">(d) &nbsp;Unlawful deduction from wages; </span><span className="s2"><br />
          </span>
          </li>
          <li className="li4"><span className="s1">(e) &nbsp;Redundancy underpayment; and </span><span className="s2"><br />
          </span>
          </li>
          <li className="li4"><span className="s1">(f) &nbsp;Breach of Contract. </span><span className="s2"><br />
          </span>
          </li>
        </ul>
        <p className="p4"><span className="s1"><b>Disbursements</b>: Expenses paid on behalf of the Client, such as experts' fees,
      court fees, photocopying, travelling expenses and translators' fees, including Counsel’s Fees.<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <p className="p4"><span className="s1">“<b>Win or winning</b>” refers to either a court or Employment Tribunal deciding in
      your favour in respect of your claim or you accept an offer of settlement in respect of your claim.<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <p className="p4"><span className="s1">“<b>Respondent/Defendant</b>” means that the organisation against whom your claim has
      been submitted under this Agreement.<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <p className="p4"><span className="s1">“<b>Losing your claim</b>” means a court or employment tribunal not awarding you any
      damages or you receiving no settlement offer.<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <p className="p4"><span className="s1">The Damages-Based Agreements Regulations 2013 applies to the Agreement.<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <p className="p4"><span className="s1">The Information Sheet forms part of this Agreement.<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <p className="p4"><b /><span className="s1"><b>2. What is covered by this Agreement</b><br /><br />
          This Agreement covers us pursuing your Claim (as defined above), including any settlement negotiations. <br />
        </span>
        </p>
        <p className="p4"><b /><span className="s1"><b>3. What is not covered by this Agreement <br />
        </b></span>
        </p>
        <p className="p4"><span className="s1">3.1 This Agreement does not cover:<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <p className="p4"><span className="s1">3.1.1 &nbsp;Any steps taken to enforce a judgment, order or agreement. </span><span className="s2"><br />
        </span>
        </p>
        <p className="p4"><span className="s1">3.1.2 &nbsp;Any reference to the Court of Justice of the European Union. </span><span className="s2"><br />
        </span>
        </p>
        <p className="p4"><span className="s1"><b>4. Our duties under this Agreement </b>
        </span>
        </p>
        <p className="p4"><span className="s1">Subject to our professional duties to the court and/or the employment tribunal, we will act in your best
        interests in pursuit of your claim. We will discuss each step of the process with you, in accordance with the
        information you have provided to us, advising you how to proceed and whether to accept any settlement offer that
         is made. <br />
        </span>
        </p>
        <p className="p4"><span className="s1"><b>5. Your duties under this Agreement </b><br />
        </span>
        </p>
        <p className="p4"><span className="s1">Your responsibilities include giving us full, honest and timely instructions, not asking us to work in an
        improper or unreasonable way, cooperating fully with us in the preparation of your claim, and paying us all
         amounts in accordance with this Agreement. <br />
        </span>
        </p>
        <p className="p4"><span className="s1"><b>6. What happens if you win?<span className="Apple-converted-space">&nbsp;</span></b></span>
        </p>
        <p className="p4"><span className="s1">6.1 If you win your case then you agree that:<span className="Apple-converted-space">&nbsp;</span></span></p>
        <p className="p4"><span className="s1">6.1.1 &nbsp;You will pay us 25% of your Compensation plus VAT on that amount ("<b>Our
         Share</b>"); and </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">6.1.2 &nbsp;At the end of the claim, after deduction of Our Share, you keep the
        remaining part of your Compensation and any legal costs awarded and appropriately apportioned to you.
         </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">6.2 We are required to inform you that we have entered into a fee sharing arrangement
        with Pay Justice Limited. This arrangement does not affect the amount you have to pay us under the terms of the
      agreement and you will not have to pay anything to Pay Justice Limited.<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <p className="p4"><span className="s1">6.2.1 In setting the damages based fee at 25% plus VAT, we have taken into
      consideration the following factors:<span className="Apple-converted-space">&nbsp;</span></span>
        </p>
        <ul className="ul1">
          <li className="li4"><span className="s1">(a) &nbsp;The likely length of proceedings </span><span className="s2"><br />
          </span>
          </li>
          <li className="li4"><span className="s1">(b) &nbsp;the value of the claim </span><span className="s2"><br />
          </span>
          </li>
          <li className="li4"><span className="s1">(c) &nbsp;the fact that you make no up-front financial contribution to our fees
         </span><span className="s2"><br />
            </span>
          </li>
          <li className="li4"><span className="s1">(d) &nbsp;the fact that we make advance payments of all disbursements on your behalf,
         including counsel's fees and any issue fees in the county court </span><span className="s2"><br />
            </span>
          </li>
          <li className="li4"><span className="s1">(e) &nbsp;the fact that we are likely to pursue a number of similar claims against your
         employer. </span><span className="s2"><br />
            </span>
          </li>
        </ul>
        <p className="p4"><span className="s1"><b>7. What happens if you lose?</b><br />
        </span>
        </p>
        <p className="p4"><span className="s1">If you lose you do not have to pay us anything, subject to clauses 8.2, 8.4, 8.5, 8.6 and 8.7. <br />
        </span>
        </p>
        <p className="p4"><span className="s1"><b>8. What if you or us want to terminate this Agreement early? </b><br />
        </span>
        </p>

        <p className="p4"><span className="s1">8.1 &nbsp;In entering this Agreement, it is our intention to reach a successful
        conclusion of your claim either before the court of employment tribunal or through settlement. However, there
         are circumstances in which either one of us may wish to end this Agreement before then. </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">8.2 &nbsp;With the exception of the circumstances set out in paragraph 8.3 below (in
        which you agree not to terminate this Agreement) you may terminate this Agreement at any time. You will then be
        liable to pay our Costs and Expenses (as defined above) incurred up to the date of termination within four weeks
         of delivery of our bill to you. </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">8.3 &nbsp;You may not terminate this Agreement after any settlement has been agreed or
         within seven days of any court or tribunal hearing. </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">8.4 &nbsp;We can end this Agreement if we consider that you have not behaved reasonably,
        for example because you have failed to meet your obligations as set out in paragraph 5. You will then be liable
        to pay our Costs and Expenses incurred up to the date of termination set out in paragraph 8.2 within 28 days of
         delivering our invoice to you. </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">8.5 &nbsp;For the avoidance of doubt, we consider that failing to accept our advice on
        whether any offer of settlement should be accepted will amount to unreasonable behaviour on your part.
         </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">8.6 &nbsp;We can also end this Agreement if we consider that you are unlikely to win and
        you disagree with us. You will then be liable to pay our Costs and Expenses incurred up to the date of
         termination. </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">8.7 &nbsp;Paragraphs 8.2 to 8.6 are without prejudice to any right of either party under
         the general laws of contract to terminate this Agreement. </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">8.8 &nbsp;If this Agreement ends in any of the circumstances set out in this in
        paragraph 8, we will tell the court or employment tribunal, Respondent/Defendant (and any of their
        representatives) that we no longer represent you. You will be free to deal with your claim on your own behalf or
        instruct someone else to do so subject to your obligation to pay our costs as set out in this clause 8.
         </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">8.9 &nbsp;Until we are paid all money that you owe us under the Agreement, we are
        entitled to a “lien” over any of your property that is in our possession. Therefore until we are paid we are
         entitled to keep your case papers. </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1"><b>9. Representation at hearings<span className="Apple-converted-space">&nbsp;</span></b></span>
        </p>
        <p className="p4"><span className="s1">9.1 &nbsp;You agree that we can instruct a barrister to represent you at any court or
        employment tribunal Hearing including any directions hearings, pre-hearing reviews, merits hearing, final
         substantive hearings and remedies hearings. </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">9.2 &nbsp;You agree not to represent yourself or to instruct anyone else to represent
         you at court or employment tribunal hearing or hearings unless we agree in advance. </span><span className="s2"><br />
          </span>
        </p>

        <p className="p4"><span className="s1"><b>10. Governing Law and Jurisdictions<span className="Apple-converted-space">&nbsp;</span></b></span></p>

        <p className="p4"><span className="s1">10.1 &nbsp;This Agreement or any dispute or claims arising out of or in connection with
        it or its subject matter shall be governed by and construed in accordance with the law of England and Wales.
         </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">10.2 &nbsp;The parties irrevocably agree that the Courts of England and Wales shall have
        jurisdiction over any dispute or claim that arises out of or in connection with this Agreement or its subject
         matter. </span><span className="s2"><br />
          </span>
        </p>
        <p className="p4"><span className="s1">This Agreement is entered into on the date that it is signed.<span className="Apple-converted-space">&nbsp;</span></span></p>
        <p className="p4"><span className="s1">By signing this Agreement you agree that you have been supplied with and read all
        necessary information in accordance with the Damages-Based Agreements Regulations 2013 and that failure to comply
        with your obligations will be deemed unreasonable behaviour for the purpose of the Damages-Based Agreements
      Regulations 2013.<span className="Apple-converted-space">&nbsp;</span></span>
        </p>

        <br />
        <img src="https://db-pj-test.s3.eu-central-1.amazonaws.com/assets/jamesSignature.png" alt="signature" style={{ height: '80px' }} />
        <p className="p4"><b>Signed by James Sharkey</b></p>
        <p className="p4"><b>on behalf of Roscoe Reid LLP</b></p>
        <p className="p4"><b>Date {moment().format('DD/MM/YYYY')}</b></p>

      </div>
    </React.Fragment>
  );
};

export default DBAContentBoots;
